/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedAffirm_item$ref = any;
type PdpSharedContactDealerButton_item$ref = any;
type PdpSharedDeposit_item$ref = any;
type PdpSharedMakeOfferButton_item$ref = any;
type PdpSharedPurchaseButton_item$ref = any;
export type PdpRespSidebarButtons_item$ref = any;
export type PdpRespSidebarButtons_item = {
    readonly isSold: boolean | null;
    readonly isInProcurement?: boolean | null;
    readonly saveSearchData: {
        readonly name: string | null;
        readonly page: string | null;
    } | null;
    readonly skus?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly displayInfo: {
            readonly ctas: {
                readonly showPurchase: boolean | null;
                readonly showMakeOffer: boolean | null;
                readonly showRequestPrice: boolean | null;
                readonly showRequestSourcing: boolean | null;
                readonly showFollowCategory: boolean | null;
                readonly showAcceptOffer: boolean | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": PdpSharedContactDealerButton_item$ref & PdpSharedPurchaseButton_item$ref & PdpSharedMakeOfferButton_item$ref & PdpSharedDeposit_item$ref & PdpSharedAffirm_item$ref;
    readonly " $refType": PdpRespSidebarButtons_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "saveSearchData",
      "storageKey": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "page",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isInProcurement",
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDeposit_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedAffirm_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "skus",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "displayInfo",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                },
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "SkuDisplayInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "ctas",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CTADisplay",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showPurchase",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showMakeOffer",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showRequestPrice",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showRequestSourcing",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showFollowCategory",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showAcceptOffer",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'ae71a021874d05130da113e1317e3e9b';
export default node;
